import { useState, useEffect, useRef } from 'react';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import useMediaQuery from '../../../hooks/useMediaQuery';

const useFilterManager = ( filterType, context, currentPostType, resetAllContextFilters ) => {
  const [ isOpen, setIsOpen ] = useState( false );
  const [ showBreadcrumb ] = useState( context?.showBreadcrumb === 'true' );

  const filterRef = useRef( null );
  const filterHeadingRef = useRef( null );
  const breadcrumbsRef = useRef( null );
  const footerRef = useRef( document.querySelector( '.site-footer' ) );
  const containerRef = useRef( document.querySelector( '.block__list-with-filters' ) );

  const isDesktop = useMediaQuery( '( min-width: 1024px )' );

  const noMenu = currentPostType === 'series' || currentPostType === 'collection';

  const [ headingIsVisible, headingPosition ] = useIntersectionObserver(
    filterType === 'api' && filterHeadingRef.current ? filterHeadingRef : { current: null }
  );

  const [ footerIsVisible ] = useIntersectionObserver(
    filterType === 'api' && footerRef.current ? footerRef : { current: null }
  );

  const openMobileFilterMenu = () => setIsOpen( true );
  const closeMobileFilterMenu = () => setIsOpen( false );

  const resetAllSortFilter = () => {
    if ( noMenu ) return;
    if ( filterType === 'team-member-grid' ) {
      resetAllContextFilters();
    } else {
      const resetButtons = document.getElementsByClassName( 'filters__btn--reset' );
      for ( const button of resetButtons ) {
        button.click();
      }
    }
  };

  const handleClickOffMainMenu = ( e ) => {
    if ( noMenu ) return;

    if ( filterRef && filterRef.current && !filterRef.current.contains( e.target ) ||
        filterRef.current.contains( e.target ) && e.target.classList.contains( 'filters__btn-close' ) ) {
      setIsOpen( false );
    }
  };

  const scrollToTop = () => window.requestAnimationFrame( () => containerRef.current.scrollIntoView() );

  useEffect( () => {
    document.body.classList.toggle( 'is-open-menu', isOpen );
    document.addEventListener( 'mousedown', handleClickOffMainMenu );
    return () => document.removeEventListener( 'mousedown', handleClickOffMainMenu );
  }, [ isOpen ] );

  return {
    // State
    isOpen,
    showBreadcrumb,
    noMenu,
    isDesktop,
    headingIsVisible,
    headingPosition,
    footerIsVisible,
    // Refs
    filterRef,
    filterHeadingRef,
    breadcrumbsRef,
    // Event Handlers
    openMobileFilterMenu,
    closeMobileFilterMenu,
    resetAllSortFilter,
    scrollToTop
  };
};

export default useFilterManager;
